import {createSlice} from "@reduxjs/toolkit"
import {markNotificationsAsRead, notificationsSlice} from "./notificationsSlice"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

// TODO: eugh... change those two values to be objects instead of arrays ::eyeroll::
const initialState = {
	currentView: 0,
	viewScrollPositionMap: [0, 0, 0],
	lastClickedNotificationMap: [null, null, null]
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialState)

const forEachWorkspace = (state, fn) => {
	for (const workspaceId in state.byWorkspace) {
		fn(state.byWorkspace[workspaceId], workspaceId)
	}
}

export const notificationPanelScrollSlice = createSlice({
	name: "notificationPanelScroll",
	initialState: {
		byWorkspace: {},
	},
	reducers: {
		setNotificationScrollPosition: (state, action) => {
			const {ratio, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			workspace.viewScrollPositionMap[workspace.currentView] = ratio
		},
		setViewLastClickedId: (state, action) => {
			//TODO: this is currently unused now that extraReducer below manipulates state directly
			const {lastClickedId, workspaceId} = action.payload
			const workspace = ensureWorkspace(state, workspaceId)
			const currentView = workspace.currentView
			workspace.lastClickedNotificationMap[currentView] = lastClickedId
		},
	},
	extraReducers: builder => {
		builder
			.addCase(
				notificationsSlice.actions.changePanelView,
				(state, action) => {
					const {index, workspaceId} = action.payload
					const workspace = ensureWorkspace(state, workspaceId)
					workspace.currentView = index
				}
			)
			.addCase(
				markNotificationsAsRead.fulfilled, (state, action) => {
					forEachWorkspace(state, (workspace) => {
						const currentView = workspace.currentView
						workspace.lastClickedNotificationMap[currentView] = action.payload
					})
				}
			)
	}
})

export const {
	setNotificationScrollPosition,
	setViewLastClickedId,
} = notificationPanelScrollSlice.actions

export const selectCurrentViewKey = (state, workspaceId) => state.notificationPanelScroll.byWorkspace[workspaceId]?.currentView ?? initialState.currentView
export const getCurrentScrollPosition = (state, workspaceId) => state.notificationPanelScroll.byWorkspace[workspaceId]?.viewScrollPositionMap[state.notificationPanelScroll.byWorkspace[workspaceId]?.currentView] ?? initialState.viewScrollPositionMap[initialState.currentView]
export const getLastClickedNotificationId = (state, workspaceId) => state.notificationPanelScroll.byWorkspace[workspaceId]?.lastClickedNotificationMap[state.notificationPanelScroll.byWorkspace[workspaceId]?.currentView] ?? initialState.lastClickedNotificationMap[initialState.currentView]

export default notificationPanelScrollSlice.reducer